






























































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import ServiceAgent from '../services/serviceAgent';
import GoogleAuthHelper from '@/helpers/GoogleAuthHelper';
import UserSettings from './UserSettings.vue';
import User from '@/objects/user';
import EventBus from '@/services/eventBus';

const serviceAgent = new ServiceAgent();
const googleAuthHelper = new GoogleAuthHelper();

@Component({
    components: {
        UserSettings,
    },
})
export default class UserInfo extends Vue {
    user: User | null = null;

    async logOut() {
        const self = this;
        EventBus.$emit('showLoader', true);

        if (this.isSignedInThroughGoogle) {
            await googleAuthHelper.GoogleLogout();
        }
        await serviceAgent.Logout();

        this.$store.dispatch('logout');
        this.$store.dispatch('clearStore');

        setTimeout(() => {
            EventBus.$emit('showLoader', false);
        }, 500);
    }

    get userId(): string {
        const result = this.$store.getters.userId;

        return result;
    }

    get isSignedInThroughGoogle() {
        const result = this.$store.getters.isSignedInThroughGoogle;

        return result;
    }

    created() {
        this.setUser();
        EventBus.$on('logout', (value: any) => {
            this.logOut();
        });
    }

    async setUser() {
        if (!this.userId) return;

        const userInfoResponse = await serviceAgent.GetUserInfo(this.userId);

        if (!userInfoResponse) return;

        this.user = new User(userInfoResponse.data);
    }

    @Watch('userId')
    async onUserIdChanged() {
        if (!this.userId) return;

        const userInfoResponse = await serviceAgent.GetUserInfo(this.userId);

        if (!userInfoResponse) return;

        this.user = new User(userInfoResponse.data);
    }
}
